import axios from 'axios';

export default {
  getWlConfig({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/wlConfig/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('insertWlConfig', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addWlConfig({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('addWlConfigRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/wlConfig/add`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('addWlConfigRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('addWlConfigRequestError', err);
          reject(err);
        });
    });
  },
  editWlConfig({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('editWlConfigRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/wlConfig/edit`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('editWlConfigRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('editWlConfigRequestError', err);
          reject(err);
        });
    });
  },
  removeWlConfig({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('removeWlConfigRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/wlConfig/destroy`,
        data: ctx,
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('removeWlConfigRequestSuccess', ctx);
          resolve(resp);
        })
        .catch(err => {
          commit('removeWlConfigRequestError', err);
          reject(err);
        });
    });
  },
  changeWlConfigIsActive({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('changeWlConfigIsActiveRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/wlConfig/changeIsActive`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('changeWlConfigIsActiveRequestSuccess', ctx);
          resolve(resp);
        })
        .catch(err => {
          commit('changeWlConfigIsActiveRequestError', err);
          reject(err);
        });
    });
  }
};
